import client from 'axiosConfig'

export interface FeedbackCampaign {
  id: number
  title: string
  message: string
  survey_url: string
  starts_at: string
  ends_at: string
}

export interface FeedbackCurrentResponse {
  campaign: FeedbackCampaign | null
  next_check_at: string | null
}

export interface FeedbackStateResponse {
  campaign_id: number
  status: string
  shown_count: number
  last_opened_at: string | null
  snoozed_until: string | null
  completed_at: string | null
}

interface FeedbackCampaignApiResponse {
  id: number
  title: string
  message: string
  surveyUrl: string
  startsAt: string
  endsAt: string
}

interface FeedbackCurrentApiResponse {
  campaign: FeedbackCampaignApiResponse | null
  nextCheckAt: string | null
}

const FeedbackService = {
  async getCurrent(): Promise<FeedbackCurrentResponse> {
    const response = await client.get('/feedback/current/')
    const data = response.data.data as FeedbackCurrentApiResponse

    return {
      campaign: data.campaign
        ? {
            id: data.campaign.id,
            title: data.campaign.title,
            message: data.campaign.message,
            survey_url: data.campaign.surveyUrl,
            starts_at: data.campaign.startsAt,
            ends_at: data.campaign.endsAt,
          }
        : null,
      next_check_at: data.nextCheckAt,
    }
  },

  async recordAction(
    campaignId: number,
    action: 'shown' | 'opened' | 'snoozed' | 'completed'
  ): Promise<FeedbackStateResponse> {
    const response = await client.post(`/feedback/${campaignId}/action/`, {
      action,
    })
    return response.data.data
  },
}

export default FeedbackService
